import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowUp_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929L15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L26.7071 13.2929C27.0976 13.6834 27.0976 14.3166 26.7071 14.7071C26.3166 15.0976 25.6834 15.0976 25.2929 14.7071L17 6.41421L17 28C17 28.5523 16.5523 29 16 29C15.4477 29 15 28.5523 15 28L15 6.41421L6.70711 14.7071C6.31658 15.0976 5.68342 15.0976 5.29289 14.7071Z"
            />
        </SvgStyled>
    );
};

export default ArrowUp_lg;
